/**
 * Normalise a raw UAE phone input into a display value (9 digits, no prefix)
 * and a storable value (+971XXXXXXXXX).
 *
 * @param {string} raw - the value from an <input> onChange event
 * @returns {{ display: string, stored: string }}
 */
export function normalizeUAEPhone(raw) {
  let digits = raw.replace(/\D/g, '');
  if (digits.startsWith('971')) digits = digits.slice(3);
  digits = digits.slice(0, 9);
  return {
    display: digits,
    stored: digits.length ? '+971' + digits : '',
  };
}

/** Returns true when the display value is a valid 9-digit UAE number (or empty). */
export function isUAEPhoneValid(display) {
  return display.length === 0 || display.length === 9;
}
